import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propChildren, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import ModalHoc from '../../../Ui/Modal/ModalHoc';
import ModalPortalHoc from '../../../Ui/Modal/ModalPortalHoc';
const ConfirmModalInner = (props) => {
    const { body, modalState, onCancel, onClick, submitting, title } = props;
    return (_jsxs("div", Object.assign({ className: 'fixed_portal_model slide_search_page' }, { children: [_jsxs("div", Object.assign({ className: clsx('confirm_modal animated-opacity', modalState) }, { children: [_jsx("div", Object.assign({ className: 'proffit_search_account_card_title' }, { children: title })), _jsxs("div", Object.assign({ className: 'modal_body' }, { children: [body, _jsx("div", Object.assign({ className: 'modal_body_row footer_row' }, { children: _jsxs("div", Object.assign({ className: 'footer_row_top' }, { children: [_jsx("button", Object.assign({ className: 'button secondary', disabled: submitting, onClick: onCancel, type: 'button' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B" })), _jsx(SubmitButton, { buttonType: 'button', className: 'button link', isDisabled: submitting, isLoading: submitting, onClick: onClick, text: '追加する' })] })) }))] }))] })), _jsx("div", { className: clsx('slide_search_modal_bg animated-opacity bg-modal', modalState), onClick: submitting ? undefined : onCancel, role: 'presentation' })] })));
};
ConfirmModalInner.propTypes = {
    body: propChildren().isRequired,
    modalState: propStr().isRequired,
    onCancel: propFunc().isRequired,
    onClick: propFunc().isRequired,
    submitting: propBool().isRequired,
    title: propStr().isRequired,
};
const ConfirmModal = compose(ModalPortalHoc({ selector: '#app' }), ModalHoc)(ConfirmModalInner);
ConfirmModal.propTypes = {
    body: propChildren().isRequired,
    isShow: propBool().isRequired,
    onCancel: propFunc().isRequired,
    onClick: propFunc().isRequired,
    submitting: propBool().isRequired,
    title: propStr().isRequired,
};
export default ConfirmModal;
